import BaseClient from '@/app/model/api/response/baseApiClient'

class VarietyGrowthListApi extends BaseClient {
  public getVarietyGrowthList (data: any) {
    const path = '/v1/master/variety-growths'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    params.append('page', data.page)

    if (data.word !== '') {
      params.append('word', data.word)
    }
    if (data.order_name !== '') {
      params.append('order_name', data.order_name)
    }
    if (data.sort === false) {
      params.append('sort', 'desc')
    } else {
      params.append('sort', 'asc')
    }
    if (data.limit !== undefined) {
      params.append('limit', data.limit)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new VarietyGrowthListApi()
